/* =========================================================
   PRODUCT PAGE WISHLIST
   Stores wishlist items in the visitor's browser.
   ========================================================= */

(function () {
  'use strict';

  const STORAGE_KEY = 'pdp_wishlist';

  /**
   * Get wishlist from localStorage
   */
  function getWishlist() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);

      if (!saved) {
        return [];
      }

      const wishlist = JSON.parse(saved);

      return Array.isArray(wishlist) ? wishlist : [];
    } catch (error) {
      console.warn('Wishlist could not be loaded:', error);
      return [];
    }
  }

  /**
   * Save wishlist to localStorage
   */
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(wishlist)
      );

      return true;
    } catch (error) {
      console.warn('Wishlist could not be saved:', error);
      return false;
    }
  }

  /**
   * Check whether product exists in wishlist
   */
  function isInWishlist(handle) {
    if (!handle) {
      return false;
    }

    const wishlist = getWishlist();

    return wishlist.includes(handle);
  }

  /**
   * Add product to wishlist
   */
  function addToWishlist(handle) {
    if (!handle) {
      return;
    }

    const wishlist = getWishlist();

    if (!wishlist.includes(handle)) {
      wishlist.push(handle);
      saveWishlist(wishlist);
    }
  }

  /**
   * Remove product from wishlist
   */
  function removeFromWishlist(handle) {
    if (!handle) {
      return;
    }

    const wishlist = getWishlist();

    const updatedWishlist = wishlist.filter(function (item) {
      return item !== handle;
    });

    saveWishlist(updatedWishlist);
  }

  /**
   * Update button appearance
   */
  function updateButton(button) {
    if (!button) {
      return;
    }

    const handle = button.getAttribute(
      'data-product-handle'
    );

    if (!handle) {
      return;
    }

    const active = isInWishlist(handle);

    button.classList.toggle(
      'is-active',
      active
    );

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    /* Update image-heart buttons */
    const labelAdd =
      button.getAttribute('data-label-add');

    const labelAdded =
      button.getAttribute('data-label-added');

    if (active) {
      if (labelAdded) {
        button.setAttribute(
          'aria-label',
          labelAdded
        );
      }

      const labelElement =
        button.querySelector('[data-wishlist-label]');

      if (labelElement && labelAdded) {
        labelElement.textContent = labelAdded;
      }

    } else {
      if (labelAdd) {
        button.setAttribute(
          'aria-label',
          labelAdd
        );
      }

      const labelElement =
        button.querySelector('[data-wishlist-label]');

      if (labelElement && labelAdd) {
        labelElement.textContent = labelAdd;
      }
    }
  }

  /**
   * Update all wishlist buttons
   */
  function updateAllButtons() {
    const buttons =
      document.querySelectorAll(
        '[data-wishlist-button]'
      );

    buttons.forEach(function (button) {
      updateButton(button);
    });
  }

  /**
   * Dispatch wishlist event
   */
  function dispatchWishlistEvent(
    handle,
    active
  ) {
    document.dispatchEvent(
      new CustomEvent(
        'pdp:wishlist-change',
        {
          detail: {
            handle: handle,
            active: active,
            wishlist: getWishlist()
          }
        }
      )
    );
  }

  /**
   * Handle wishlist click
   */
  function handleWishlistClick(event) {
    const button =
      event.target.closest(
        '[data-wishlist-button]'
      );

    if (!button) {
      return;
    }

    event.preventDefault();

    const handle =
      button.getAttribute(
        'data-product-handle'
      );

    if (!handle) {
      return;
    }

    const currentlyActive =
      isInWishlist(handle);

    if (currentlyActive) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }

    /*
     * Update every button for the same product.
     * This is important because we have:
     * - heart on the product image
     * - wishlist button in product information
     */
    const buttons =
      document.querySelectorAll(
        '[data-wishlist-button]'
      );

    buttons.forEach(function (item) {
      const itemHandle =
        item.getAttribute(
          'data-product-handle'
        );

      if (itemHandle === handle) {
        updateButton(item);
      }
    });

    dispatchWishlistEvent(
      handle,
      !currentlyActive
    );
  }

  /**
   * Initialize wishlist
   */
  function initWishlist() {
    updateAllButtons();

    document.addEventListener(
      'click',
      handleWishlistClick
    );
  }

  /**
   * Run when DOM is ready
   */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initWishlist
    );
  } else {
    initWishlist();
  }

  /*
   * Make wishlist functions available
   * to other theme scripts if needed.
   */
  window.PDPWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    updateButtons: updateAllButtons
  };

})();